import { alpha, Input, styled, Typography } from '@mui/material';

export const CommentItemUserName = styled(Typography)({
    fontSize: '11px',
    textTransform: 'uppercase',
    fontWeight: '700',
    lineHeight: 'normal',
    letterSpacing: '0.44px',
});

export const ChatInput = styled(Input)(({ theme }) => ({
    border: 'none',
    padding: '16px',
    color: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.text.primary,
    background: theme.palette.mode === 'dark' ? alpha(theme.palette.primary.main, 0.05) : theme.custom.c7,
    borderRadius: '16px',
    fontSize: '1rem',
    width: '100%',
    '&:focus': {
        outline: 'none',
    },
    '&:placeholder': {
        color: theme.palette.info.light,
    },
    '& input': {
        padding: '0',
    },
}));
